/** Вкл.: dev-сборка или localStorage debugPopoverPosition = 1 */
export function shouldLogPopoverPosition(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return globalThis.localStorage?.getItem('debugPopoverPosition') === '1';
  } catch {
    return false;
  }
}

export function logPopoverPosition(scope: string, message: string, data?: Record<string, unknown>): void {
  if (!shouldLogPopoverPosition()) return;
  if (data !== undefined) console.log(`[popover-pos][${scope}]`, message, data);
  else console.log(`[popover-pos][${scope}]`, message);
}

export function logFilterPopover(message: string, data?: Record<string, unknown>): void {
  if (!shouldLogPopoverPosition()) return;
  if (data !== undefined) console.log('[filter-popover]', message, data);
  else console.log('[filter-popover]', message);
}
